/**
 * Also available (single, desktop): hard-lock cover to a square = body height.
 * Mobile stacks the card — clear forced sizes so CSS can take over.
 */
(function () {
  var scheduled = false;
  var MOBILE = '(max-width: 639px)';

  function clear(card, media) {
    card.style.removeProperty('--wbw-promo-sq');
    ['width', 'height', 'min-width', 'min-height', 'max-width', 'max-height', 'flex', 'aspect-ratio', 'align-self'].forEach(
      function (prop) {
        media.style.removeProperty(prop);
      }
    );
  }

  function apply(card, media, side) {
    card.style.setProperty('--wbw-promo-sq', side + 'px');
    media.style.setProperty('width', side + 'px', 'important');
    media.style.setProperty('height', side + 'px', 'important');
    media.style.setProperty('min-width', side + 'px', 'important');
    media.style.setProperty('min-height', side + 'px', 'important');
    media.style.setProperty('max-width', side + 'px', 'important');
    media.style.setProperty('max-height', side + 'px', 'important');
    media.style.setProperty('flex', '0 0 ' + side + 'px', 'important');
    media.style.setProperty('aspect-ratio', '1 / 1', 'important');
    media.style.setProperty('align-self', 'stretch', 'important');
  }

  function sizePromoSquares(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var mobile = window.matchMedia && window.matchMedia(MOBILE).matches;
    scope.querySelectorAll('.wbw-sibling-promo-grid--single .wbw-sibling-promo-card').forEach(function (card) {
      var media = card.querySelector('.wbw-sibling-promo-card__media');
      var body = card.querySelector('.wbw-sibling-promo-card__body');
      if (!media || !body) return;
      if (mobile) {
        clear(card, media);
        return;
      }
      var cardW = Math.floor(card.getBoundingClientRect().width);
      var side = 0;
      for (var i = 0; i < 4; i++) {
        var h = Math.ceil(body.getBoundingClientRect().height);
        if (h < 8) break;
        var next = cardW > 0 ? Math.min(h, Math.floor(cardW * 0.5)) : h;
        if (next === side) break;
        side = next;
        apply(card, media, side);
      }
    });
  }

  function schedule(root) {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      sizePromoSquares(root || document);
    });
  }

  function boot() {
    schedule(document);
    requestAnimationFrame(function () {
      schedule(document);
    });
    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(function () {
        schedule(document);
      });
      document.querySelectorAll('.wbw-sibling-promo-grid--single .wbw-sibling-promo-card').forEach(function (card) {
        ro.observe(card);
        var body = card.querySelector('.wbw-sibling-promo-card__body');
        if (body) ro.observe(body);
      });
    }
  }

  window.__wbwSizePromoSquares = function (root) {
    schedule(root || document);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', function () {
    schedule(document);
  });
  window.addEventListener('resize', function () {
    schedule(document);
  });
})();
